import type { Routes } from '@angular/router';
import { authGuard } from './services/auth.guard';
import { followUpLoaders, thankYouLoader } from './preloading/follow-up-loaders';
import { ScreeningResolver } from './services/screening.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./welcome-page/welcome-page.component').then(module => module.WelcomePageComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login-page/login-page').then(module => module.LoginPageComponent),
  },
  {
    path: 'login-rep',
    loadComponent: () =>
      import('./login-page/login-page').then(module => module.LoginPageComponent),
    data: { layout: 'rep' },
  },
  {
    path: 'initial-questions',
    loadComponent: () =>
      import('./question0-initial/question0-initial').then(module => module.InitialQuestions),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question1-follow-up',
    loadComponent: () => followUpLoaders[1](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question2-follow-up',
    loadComponent: () => followUpLoaders[2](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question3-follow-up',
    loadComponent: () => followUpLoaders[3](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question4-follow-up',
    loadComponent: () => followUpLoaders[4](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question5-follow-up',
    loadComponent: () => followUpLoaders[5](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question6-follow-up',
    loadComponent: () => followUpLoaders[6](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question7-follow-up',
    loadComponent: () => followUpLoaders[7](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question8-follow-up',
    loadComponent: () => followUpLoaders[8](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question9-follow-up',
    loadComponent: () => followUpLoaders[9](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question10-follow-up',
    loadComponent: () => followUpLoaders[10](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question11-follow-up',
    loadComponent: () => followUpLoaders[11](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question12-follow-up',
    loadComponent: () => followUpLoaders[12](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'question13-follow-up',
    loadComponent: () => followUpLoaders[13](),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-adult-q1',
    loadComponent: () =>
      import('./chat-adult-q1/chat-adult-q1').then(module => module.ChatAdultQ1),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q1',
    loadComponent: () =>
      import('./chat-peds-q1/chat-peds-q1').then(module => module.ChatPedsQ1),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q2',
    loadComponent: () =>
      import('./chat-peds-q2/chat-peds-q2').then(module => module.ChatPedsQ2),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q3',
    loadComponent: () =>
      import('./chat-peds-q3/chat-peds-q3').then(module => module.ChatPedsQ3),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q4',
    loadComponent: () =>
      import('./chat-peds-q4/chat-peds-q4').then(module => module.ChatPedsQ4),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q5',
    loadComponent: () =>
      import('./chat-peds-q5/chat-peds-q5').then(module => module.ChatPedsQ5),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q6',
    loadComponent: () =>
      import('./chat-peds-q6/chat-peds-q6').then(module => module.ChatPedsQ6),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q7',
    loadComponent: () =>
      import('./chat-peds-q7/chat-peds-q7').then(module => module.ChatPedsQ7),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q8',
    loadComponent: () =>
      import('./chat-peds-q8/chat-peds-q8').then(module => module.ChatPedsQ8),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q9',
    loadComponent: () =>
      import('./chat-peds-q9/chat-peds-q9').then(module => module.ChatPedsQ9),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q10',
    loadComponent: () =>
      import('./chat-peds-q10/chat-peds-q10').then(module => module.ChatPedsQ10),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q11',
    loadComponent: () =>
      import('./chat-peds-q11/chat-peds-q11').then(module => module.ChatPedsQ11),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q12',
    loadComponent: () =>
      import('./chat-peds-q12/chat-peds-q12').then(module => module.ChatPedsQ12),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q13',
    loadComponent: () =>
      import('./chat-peds-q13/chat-peds-q13').then(module => module.ChatPedsQ13),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q14',
    loadComponent: () =>
      import('./chat-peds-q14/chat-peds-q14').then(module => module.ChatPedsQ14),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q15',
    loadComponent: () =>
      import('./chat-peds-q15/chat-peds-q15').then(module => module.ChatPedsQ15),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q16',
    loadComponent: () =>
      import('./chat-peds-q16/chat-peds-q16').then(module => module.ChatPedsQ16),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'chat-peds-q17',
    loadComponent: () =>
      import('./chat-peds-q17/chat-peds-q17').then(module => module.ChatPedsQ17),
    canActivate: [authGuard],
    resolve: { screening: ScreeningResolver },
  },
  {
    path: 'thank-you',
    loadComponent: () => thankYouLoader(),
  },
  {
    path: '500',
    loadComponent: () => import('./error-page/error-page').then(module => module.ErrorPage),
    data: { errorCode: '500' },
  },
  {
    path: '503',
    loadComponent: () => import('./error-page/error-page').then(module => module.ErrorPage),
    data: { errorCode: '503' },
  },
  {
    path: '**',
    loadComponent: () => import('./error-page/error-page').then(module => module.ErrorPage),
    data: { errorCode: '404' },
  },
];
